<template>
    <ot-section v-bind="$attrs" :theme="$otTheme" section>
        <ot-row-group :theme="$otTheme" :code="code" vertical>
            <ot-lazy-load :theme="$otTheme">
                <div :class="$style.box">
                    <span>OT-UI --> LazyLoad</span>
                    <img :src="src" alt="">
                </div>
            </ot-lazy-load>
        </ot-row-group>
    </ot-section>
</template>

<script>
export default {
    data() {
        return {
            src: 'https://drscdn.500px.org/photo/195143459/h%3D1065/v2?webp=true&sig=c9db37fe0017a0479f01bb2a010c88ef4748bcb3a9ef4c58494c20a3fd945fc6',
            code: decodeURIComponent(`%3Ctemplate%3E%0A%20%20%20%20%3Cot-section%20section%3E%0A%20%20%20%20%20%20%20%20%3Cot-row-group%20%3Acode%3D%22code%22%20vertical%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%3Cot-lazy-load%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cdiv%20%3Aclass%3D%22%24style.box%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cspan%3EOT-UI%20--%3E%20LazyLoad%3C%2Fspan%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cimg%20%3Asrc%3D%22src%22%20alt%3D%22%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fdiv%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fot-lazy-load%3E%0A%20%20%20%20%20%20%20%20%3C%2Fot-row-group%3E%0A%20%20%20%20%3C%2Fot-section%3E%0A%3C%2Ftemplate%3E%0A%0A%3Cscript%3E%0Aexport%20default%20%7B%0A%20%20%20%20data()%20%7B%0A%20%20%20%20%20%20%20%20return%20%7B%0A%20%20%20%20%20%20%20%20%20%20%20%20src%3A%20'https%3A%2F%2Fdrscdn.500px.org%2Fphoto%2F195143459%2Fh%253D1065%2Fv2%3Fwebp%3Dtrue%26sig%3Dc9db37fe0017a0479f01bb2a010c88ef4748bcb3a9ef4c58494c20a3fd945fc6'%2C%0A%20%20%20%20%20%20%20%20%7D%3B%0A%20%20%20%20%7D%2C%0A%7D%3B%0A%3C%2Fscript%3E%0A%0A%3Cstyle%20lang%3D%22scss%22%20module%3E%0A.box%20%7B%0A%20%20%20%20width%3A%20600px%3B%0A%20%20%20%20height%3A%20100%25%3B%0A%7D%0A%3C%2Fstyle%3E`),
        };
    },
};
</script>

<style lang="scss" module>
.box {
    width: 600px;
    height: 100%;
}
</style>
